import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Home } from "lucide-react";
import { Button } from "@/components/ui/button";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center max-w-md mx-auto px-4">
        <div className="mb-8">
          <h1 className="text-6xl md:text-8xl font-heading font-bold text-primary mb-4">
            404
          </h1>
          <h2 className="text-2xl md:text-3xl font-heading font-semibold mb-4">
            Page Not Found
          </h2>
          <p className="text-lg text-muted-foreground font-body mb-8">
            The page you're looking for doesn't exist or has been moved.
          </p>
        </div>
        
        <Button asChild size="lg" className="gap-2">
          <Link to="/" aria-label="Return to Flexaura homepage">
            <Home className="w-4 h-4" aria-hidden="true" />
            Back to Home
          </Link>
        </Button>
        
        <div className="mt-8 text-sm text-muted-foreground">
          <p>Need help? Contact us at <a 
            href="mailto:hector@flexaura.me" 
            className="text-primary hover:underline focus:underline focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 rounded"
          >
            hector@flexaura.me
          </a></p>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
